<template>
<div id="productDetailModal" class="ui basic large long modal" style="min-height:99vh;">

<a v-show="galleryPrevButton" @click.prevent.stop="galleryPrev" style="position:absolute;top:200px;left:-10%;opacity:.4;" class="ui massive circular inverted basic icon button"><i class="left chevron icon" ></i></a>

  <div v-if="productIDs.length>0" class="header prodDetOverlayHeader">
    <i :class="''+($parent.$parent.worldStore.products[productIDs[index]].marketplace ? $parent.$parent.worldStore.products[productIDs[index]].marketplace.toLowerCase().replace('uk','gb') : 'us')+' flag'"></i>
    <a :href="$parent.$parent.worldStore.products[productIDs[index]].productUrl"
      target="_blank"
      data-tooltip="View Product On Amazon" data-inverted="" data-position="right center">
      <i class="blue external share icon"></i>
      {{ $parent.$parent.worldStore.products[productIDs[index]].productUrl ? $parent.$parent.worldStore.products[productIDs[index]].productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, "$1") : 'N/A' }}
      -
      {{$parent.$parent.worldStore.products[productIDs[index]].productTitle}}</a>
  </div>

  <div v-if="productIDs.length>0" class="content ">
      <div class="ui stackable grid" id="muteAble">

        <div class="five wide column">

          <div class="ui image">
            <div class="floating ui grey label" v-if="productIDs.length>1&&$parent.$parent.worldStore.products[productIDs[index]].productGroupProductIds.length>1" style="left:93%;">
              {{numInGroup()}}&nbsp;&nbsp;of&nbsp;&nbsp;{{$parent.$parent.worldStore.products[productIDs[index]].productGroupProductIds.length}}
            </div>

            <div
              v-if="$parent.$parent.worldStore.products[productIDs[index]].isAdultFlag"
              data-tooltip="!! Adult Item flag in ON - product does not appear on standard amazon search !!"
              data-position="right center"
              class="floating ui big red label"
              style="left:-2%;top:-5%;">
              <i class="icon circle warning"></i> 18+
            </div>

            <img :src="$parent.$parent.worldStore.products[productIDs[index]].largeImageUrl" class="ui image medium" style="max-height: 240px; max-width: 240px; height: auto; width: auto; border-radius:3px;">
          </div>

          <div v-if="$parent.$parent.worldStore.products[productIDs[index]].ageHours > -1">
          <br/>

          <div v-if="$parent.$parent.worldStore.products[productIDs[index]].bsrRank!==null">
            BSR <small>(24h avg.): </small>
            <span style="color:#a291fb; font-weight:bold;">
              {{$parent.$parent.worldStore.products[productIDs[index]].bsrRank}}
            </span>
          </div>

          <div class="ui inverted segment" style="width:275px; border: 1px solid #333;">
            <div class="ui inverted violet tiny statistic" style="position:relative;">
              <div class="label">today so far</div>
              <div class="label"><small>{{$parent.$parent.worldStore.products[productIDs[index]].sales && $parent.$parent.worldStore.products[productIDs[index]].sales[0] ? $parent.$parent.worldStore.products[productIDs[index]].sales[0].day : 'N/A'}} {{$parent.$parent.worldStore.products[productIDs[index]].sales && $parent.$parent.worldStore.products[productIDs[index]].sales[0] ? toMonth($parent.$parent.worldStore.products[productIDs[index]].sales[0].month) : ''}}  &nbsp; ({{$parent.$parent.worldStore.products[productIDs[index]].marketplace}})</small></div>
              <div class="value">{{$parent.$parent.worldStore.products[productIDs[index]].sales && $parent.$parent.worldStore.products[productIDs[index]].sales[0] ? $parent.$parent.worldStore.products[productIDs[index]].sales[0].unitsSold : 0}}</div>
              <div class="label"><i class="cube icon"></i>units</div>
            </div>

            <div class="ui inverted violet tiny statistic">
              <div class="label">yesterday</div>
              <div class="label"><small>{{$parent.$parent.worldStore.products[productIDs[index]].sales && $parent.$parent.worldStore.products[productIDs[index]].sales[1] ? $parent.$parent.worldStore.products[productIDs[index]].sales[1].day : 'N/A'}} {{$parent.$parent.worldStore.products[productIDs[index]].sales && $parent.$parent.worldStore.products[productIDs[index]].sales[1] ? toMonth($parent.$parent.worldStore.products[productIDs[index]].sales[1].month) : ''}} &nbsp; ({{$parent.$parent.worldStore.products[productIDs[index]].marketplace}})</small></div>
              <div class="value">{{$parent.$parent.worldStore.products[productIDs[index]].sales && $parent.$parent.worldStore.products[productIDs[index]].sales[1] ? $parent.$parent.worldStore.products[productIDs[index]].sales[1].unitsSold : 0}}</div>
              <div class="label"><i class="cube icon"></i>units</div>
            </div>

            <div v-if="$parent.$parent.worldStore.products[productIDs[index]].productGroupProductIds.length>1">
              <div class="ui inverted brown tiny statistic">
                <div class="label" style="visibility:hidden; height:0;">today so far</div>
                <div class="value">{{salesCount('t', productIDs[index], 'unitsSold')}}</div>
                <div class="label"><i class="cube icon"></i>units</div>
                <div class="label"><small>total in grp</small></div>
              </div>
              <div class="ui inverted brown tiny statistic">
                <div class="label" style="visibility:hidden; height:0;">yesterday</div>
                <div class="value">{{salesCount('y', productIDs[index], 'unitsSold')}}</div>
                <div class="label"><i class="cube icon"></i>units</div>
                <div class="label"><small>total in grp</small></div>
              </div>
            </div>

            <!-- Promo Codes -->
            <div style="width:110px; float:left; margin:0 9px 1px 0;" v-for="day in ['today', 'ytd']">
              <span class="ui brown tiny tag label" v-show="hasPromoCodes(day)">Promo codes</span>
              <small v-for="(val, key) in promoCodes[day]"
                style="display:block;"
                :data-tooltip="key+' : '+val.units+' units from '+val.orders+' orders'"
                data-position="right center"
                >
                <span v-if="val.units!==val.orders">
                   - {{key.slice(0,25)}}: <span style="color:#fa5;">&nbsp;{{val.units}}</span>&nbsp;(&nbsp;from&nbsp;<span style="color:#fa5;">{{val.orders}}</span>&nbsp;ord.)
                </span>
                <span v-else>
                   - {{key.slice(0,25)}}: <span style="color:#fa5;">&nbsp;{{val.units}}&nbsp;units</span>
                </span>
              </small>
              <small v-show="hasPromoCodes(day)" style="color:grey;">
                - no code:
                  {{salesCount(day, productIDs[index], 'organicUnits')}} u.
                  ({{salesCount(day, productIDs[index], 'organicOrders')}} ord.)
              </small>
            </div>
            <div style="clear:both;"></div>

            <button
              class="ui mini compact basic brown button"
              style="padding:3px 6px; font-size:10px;"
              v-on:click="$parent.$parent.$refs.chartModal.open($parent.$parent.worldStore.products[productIDs[index]], 'productDetailModal')">
              See full month...
            </button>
          </div>

          <div v-if="$parent.$parent.worldStore.products[productIDs[index]].fbaFeeEstimate!==null">
            FBA Fee estimate: <span style="color:yellow;">
              {{$parent.$parent.worldStore.products[productIDs[index]].fbaFeeEstimate}}
            </span> <br />
            <small>(based on current weight and size)</small>
          </div>

          </div>
          <div v-else>
            <br><br><br>
            Syncing in progress.<br> Sales and Promo-code data not yet available.
          </div>
        </div>

        <div class="six wide column">
          <h4 style="margin-left:0px;">Product Listing Health</h4>
          <div class="ui inverted relaxed divided list" style="margin-left:0px;">

            <div class="item"
              :class="{'muteAble' : !currentProductWatchDogs[i.wdType].muted &&(currentProductWatchDogs[i.wdType].status==1 || currentProductWatchDogs[i.wdType].status==2), 'issueSt0': currentProductWatchDogs[i.wdType].issueStatus==0, 'issueSt1': currentProductWatchDogs[i.wdType].issueStatus==1, 'issueSt2': currentProductWatchDogs[i.wdType].issueStatus==2, 'issueSt3': currentProductWatchDogs[i.wdType].issueStatus==3, 'stts21kdfslds' : (currentProductWatchDogs[i.wdType].status==21)}"
              v-for="i in wdDet"
              v-if="currentProductWatchDogs[i.wdType]"
              :data-wdtype="i.wdType"
            >
              <i v-if="i.wdType=='lostBuybox' && currentProductWatchDogs[i.wdType].statusDetails && currentProductWatchDogs[i.wdType].statusDetails.message && currentProductWatchDogs[i.wdType].statusDetails.message.indexOf('no offers from any sellers') >= 0 " class="right grey warning circle icon"></i>
              <i v-else @click="cycleIssueStatus(i.wdType, productIDs[index])" :class="getIconClasses(currentProductWatchDogs[i.wdType])"></i>

              <div class="content" style="width:100%; color: #8a8a8a;">
                <div class="header">
                  <i v-if="currentProductWatchDogs[i.wdType].muted" class=" mute alarm outline icon"></i>

                  <span v-if="!currentProductWatchDogs[i.wdType].muted&&currentProductWatchDogs[i.wdType].status>0">
                    <span v-if="currentProductWatchDogs[i.wdType].issueStatus==1" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Seen</span>
                    <span v-if="currentProductWatchDogs[i.wdType].issueStatus==2" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">In Progress</span>
                    <span v-if="currentProductWatchDogs[i.wdType].issueStatus==3" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Done</span>
                  </span>

                  <a v-if="i.wdType=='badReview'"
                    :href="$parent.$parent.worldStore.products[productIDs[index]].productReviewsUrl"
                    target="_blank"
                    data-tooltip="View The Latest Reviews On Amazon" data-inverted="" data-position="right center">
                    {{i.wdName}} <i class="blue external share icon"></i>
                  </a>
                  <a v-else-if="i.wdType=='topReview'"
                    :href="$parent.$parent.worldStore.products[productIDs[index]].productTopReviewsUrl"
                    target="_blank"
                    data-tooltip="View The Top Rated Reviews On Amazon" data-inverted="" data-position="right center">
                    {{i.wdName}} <i class="blue external share icon"></i>
                  </a>
                  <a v-else-if="i.wdType=='lostBuybox'"
                    :href="$parent.$parent.worldStore.products[productIDs[index]].productOffersUrl"
                    target="_blank"
                    data-tooltip="View All Offer For This ASIN On Amazon" data-inverted="" data-position="right center">
                    {{i.wdName}} <i class="blue external share icon"></i>
                  </a>
                  <span v-else-if="i.wdType=='salesDrop'">
                    {{i.wdName}} &nbsp;
                    <div class="ui brown compact basic icon button"
                        style="float:right; margin:1px; "
                        v-on:click="$parent.$parent.$refs.chartModal.open($parent.$parent.worldStore.products[productIDs[index]], 'productDetailModal')">
                      <i class=" large chart bar outline icon"></i>
                    </div>
                    <div v-if="$parent.$parent.onboarding.saleschrt" @click.stop.prevent="$parent.$parent.onboarder('saleschrt')" class="onboarding ui right pointing large yellow label labelCursorFix" data-onboarding="saleschrt" style="position:absolute; left:160px; cursor:pointer;">
                      Detailed Sales Chart + BSR<br/>
                      <small style="float:right;margin-top: 5px;">Click this note to dismiss</small>
                    </div>
                  </span>
                  <span v-else>
                    {{i.wdName}}
                  </span>

                </div>

                <span v-if="i.wdType=='topReview' || i.wdType=='badReview'" v-html="prettyfyReviewText(currentProductWatchDogs[i.wdType].statusDetails.message)"></span>
                <span v-else-if="i.wdType=='starRatingRecentChange'" v-html="prettyfyRatingText(currentProductWatchDogs[i.wdType].statusDetails.message)"></span>
                <span v-else v-text="currentProductWatchDogs[i.wdType].statusDetails.message"></span>

              </div>
            </div>

          </div>
        </div>

        <div class="five wide column">
          <div
            class="ui inverted segment"
            v-if="currentProductWatchDogs.inventory && currentProductWatchDogs.inventory.status !== 21"
            style="border: 1px solid #333;">
            <h4>FBA Stock level</h4>
            <div class="ui inverted relaxed list" >
              <div class="item inventoryItem"
                  :class="{'muteAble' : !currentProductWatchDogs.inventory.muted &&(currentProductWatchDogs.inventory.status==1 || currentProductWatchDogs.inventory.status==2), 'issueSt0': currentProductWatchDogs.inventory.issueStatus==0, 'issueSt1': currentProductWatchDogs.inventory.issueStatus==1, 'issueSt2': currentProductWatchDogs.inventory.issueStatus==2, 'issueSt3': currentProductWatchDogs.inventory.issueStatus==3}">
                <i class="big " @click="cycleIssueStatus('inventory', productIDs[index])" :class="getIconClasses(currentProductWatchDogs.inventory)"></i>
                <div class="content">
                  <div
                    class="header"
                    style="color:grey;"
                    v-html="currentProductWatchDogs.inventory.statusDetails && currentProductWatchDogs.inventory.statusDetails.message ? currentProductWatchDogs.inventory.statusDetails.message.replace(/\(.*\)/gi,'').replace(/(\d+)/gi, '<span style=\'color:white;\'>$1</span>') : ''"></div>
                  <div
                    class="description"
                    style="padding-top:4px;"
                    v-if="currentProductWatchDogs.inventory.statusDetails && currentProductWatchDogs.inventory.statusDetails.message && currentProductWatchDogs.inventory.statusDetails.message.indexOf('No alert threshold') !== -1"
                    data-tooltip="You can set Inventory alerts on the 'FBA Stock' tab">
                    <small style="color:orange;">[No FBA Inventory Alerts Set - hover for more]</small>
                  </div>
                  <div
                    class="description"
                    style="padding-top:4px;"
                    v-if="currentProductWatchDogs.inventory.statusDetails && currentProductWatchDogs.inventory.statusDetails.message && currentProductWatchDogs.inventory.statusDetails.message.toLowerCase().indexOf('(') > -1">

                    <i v-if="currentProductWatchDogs.inventory.muted" class=" mute alarm outline icon"></i>

                    <span v-if="(!currentProductWatchDogs.inventory.muted)&&currentProductWatchDogs.inventory.status>0">

                      <small v-if="currentProductWatchDogs.inventory.issueStatus==1" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Seen</small>
                      <small v-if="currentProductWatchDogs.inventory.issueStatus==2" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">In Progress</small>
                      <small v-if="currentProductWatchDogs.inventory.issueStatus==3" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Done</small>

                    </span>

                    <small>{{currentProductWatchDogs.inventory.statusDetails && currentProductWatchDogs.inventory.statusDetails.message ? currentProductWatchDogs.inventory.statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace('No alert threshold set; est', 'Est') : ''}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="ui inverted segment"
            v-if="currentProductWatchDogs.fbmInventory && currentProductWatchDogs.fbmInventory.status !== 21"
            style="border: 1px solid #333;">
            <h4>FBM Stock level</h4>
            <div class="ui inverted relaxed list" >
              <div class="item fbmInventoryItem"
                  :class="{'muteAble' : !currentProductWatchDogs.fbmInventory.muted &&(currentProductWatchDogs.fbmInventory.status==1 || currentProductWatchDogs.fbmInventory.status==2), 'issueSt0': currentProductWatchDogs.fbmInventory.issueStatus==0, 'issueSt1': currentProductWatchDogs.fbmInventory.issueStatus==1, 'issueSt2': currentProductWatchDogs.fbmInventory.issueStatus==2, 'issueSt3': currentProductWatchDogs.fbmInventory.issueStatus==3}">
                <i class="big " @click="cycleIssueStatus('fbmInventory', productIDs[index])" :class="getIconClasses(currentProductWatchDogs.fbmInventory)"></i>
                <div class="content">
                  <div
                    class="header"
                    style="color:grey;"
                    v-html="currentProductWatchDogs.fbmInventory.statusDetails && currentProductWatchDogs.fbmInventory.statusDetails.message ? currentProductWatchDogs.fbmInventory.statusDetails.message.replace(/\(.*\)/gi,'').replace(/(\d+)/gi, '<span style=\'color:white;\'>$1</span>') : ''"></div>
                  <div
                    class="description"
                    style="padding-top:4px;"
                    v-if="currentProductWatchDogs.fbmInventory.statusDetails && currentProductWatchDogs.fbmInventory.statusDetails.message && currentProductWatchDogs.fbmInventory.statusDetails.message.indexOf('No alert threshold') !== -1"
                    data-tooltip="You can set Inventory alerts on the 'FBM Stock' tab">
                    <small style="color:orange;">[No FBM Inventory Alerts Set - hover for more]</small>
                  </div>
                  <div
                    class="description"
                    style="padding-top:4px;"
                    v-if="currentProductWatchDogs.fbmInventory.statusDetails && currentProductWatchDogs.fbmInventory.statusDetails.message && currentProductWatchDogs.fbmInventory.statusDetails.message.toLowerCase().indexOf('(') > -1">

                    <i v-if="currentProductWatchDogs.fbmInventory.muted" class=" mute alarm outline icon"></i>

                    <span v-if="(!currentProductWatchDogs.fbmInventory.muted)&&currentProductWatchDogs.fbmInventory.status>0">

                      <small v-if="currentProductWatchDogs.fbmInventory.issueStatus==1" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Seen</small>
                      <small v-if="currentProductWatchDogs.fbmInventory.issueStatus==2" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">In Progress</small>
                      <small v-if="currentProductWatchDogs.fbmInventory.issueStatus==3" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Done</small>

                    </span>

                    <small>{{currentProductWatchDogs.fbmInventory.statusDetails && currentProductWatchDogs.fbmInventory.statusDetails.message ? currentProductWatchDogs.fbmInventory.statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace('No alert threshold set; est', 'Est') : ''}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4>Primary Keywords Search Rank</h4>
          <div id="keywordsList" class="ui inverted relaxed list" v-if="currentProductKeywords.length > 0">

            <div class="item"
            :class="{'muteAble' : (k.status==1 || k.status==2)&&!k.muted, 'issueSt0': k.issueStatus==0, 'issueSt1': k.issueStatus==1, 'issueSt2': k.issueStatus==2, 'issueSt3': k.issueStatus==3}"
              v-for="k, i in currentProductKeywords"
              :key="k.watchDogItemId"
              >
              <i :class="getIconClasses(k)" @click="cycleKeywordIssueStatus(productIDs[index], i)"></i>
              <div class="content" style="width:100%;">
                <div class="header">
                  <i v-if="k.muted" class=" mute alarm outline icon"></i>

                  <span v-if="!k.muted&&(k.status==1||k.status==2)">
                    <span v-if="k.issueStatus==1" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Seen</span>
                    <span v-if="k.issueStatus==2" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">In Progress</span>
                    <span v-if="k.issueStatus==3" class="ui mini circular blue label" style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;">Done</span>
                  </span>

                  <a :href="'http://'+ amaSites[k.marketplace] +'/s/?field-keywords='+ (k.settings && k.settings.keyword ? k.settings.keyword : '')" target="_blank" data-tooltip="View Keyword On Amazon" data-inverted="" data-position="right center">
                    "{{k.settings && k.settings.keyword ? k.settings.keyword : 'N/A'}}"
                    <i class="blue external share icon"></i>
                  </a>
                  <small v-if="k.settings && k.settings.absoluteThreshold > 0 && k.settings.absoluteThreshold < 1000"
                    style="color:#aaa;"
                    :data-tooltip="'Alert if rank falls below ' + k.settings.absoluteThreshold" data-position="top center"
                    >
                    (<i class="right small alarm icon"></i>&lt; rank {{k.settings.absoluteThreshold}})
                  </small>
                  <a v-if="k.hasOwnProperty('watchDogId')"
                    class="removeKeyword"
                    :data-wdid="k.watchDogId"
                    @click.shift.prevent="removeKeyword(k.watchDogId)"
                    data-tooltip="Hold [Shift] + Click To Remove" data-position="top center"
                  >Del Kwrd</a>
                </div>
                {{k.statusDetails.message}}
              </div>
            </div>

          </div>

          <button
            v-if="!showAddKeywordForm && currentProductKeywords.length < 8"
            class="ui mini compact basic labeled icon button teal"
            :class="{'olive' : currentProductKeywords.length == 0 }"
            @click="showAddKeywordForm=true"
            style="position:absolute;"
            >
            <i class="plus icon"></i>Add
          </button>
          <transition name="fade">
          <div id="addNewKeywordForm" class="ui mini form" v-show="showAddKeywordForm">

              <div class="eleven wide required field">
                <input name="newKeyword" type="text" placeholder="New Keyword Phrase To Track" value=''>
              </div>

              <div class="inline fields">
                <label style='color:#fff;'>Alert if rank falls below this rank : &nbsp;</label>
                <div class="three wide field" data-tooltip="Rank 1-150 or leave blank for no Alerts" data-position="bottom center">
                 <input name="newTreshold" type="text" placeholder="Rank" value=''>
                </div>
              </div>

              <div class="field">
                <div class="ui mini submit primary button" @click="addNewKeyword">Submit</div>
                <div class="ui mini button" @click="showAddKeywordForm=false">Cancel</div>
              </div>

          </div>
          </transition>
        </div>

      </div>

  </div>
  <div class="actions">
    hit ESC or click
    <div class="ui inverted button" @click="hide()">OK</div>
  </div>

<a v-show="galleryNextButton" @click.prevent.stop="galleryNext" style="position:absolute;top:200px;right:-10%;opacity:.4;" class="ui massive circular inverted basic icon button"><i class="right chevron icon" ></i></a><br>

</div>
</template>

<script>
import $ from 'jquery'
export default {
  data: function () {
    return {
      showAddKeywordForm: false,
      wdDet: [
        {wdType: 'starRatingRecentChange', wdName: 'Star Rating'},
        {wdType: 'badReview', wdName: 'Latest Reviews'},
        {wdType: 'topReview', wdName: 'Top Rated Reviews'},
        {wdType: 'noAddToCart', wdName: 'Has an add-to-cart button'},
        {wdType: 'lostBuybox', wdName: 'Buy-box'},
        {wdType: 'numberOfSellers', wdName: 'Hijacker Alert'},
        // {wdType: 'price', wdName: 'Price'},
        {wdType: 'salesDrop', wdName: 'Sales Volume'},
        {wdType: 'imageMissing', wdName: 'Has a Main Image'},
        {wdType: 'productDetailsRecentChange', wdName: 'Title, Bullets, Description changes'},
        {wdType: 'productCategoryRecentChange', wdName: 'Sub-category change'},
        {wdType: 'bestSellerBadge', wdName: 'Best Seller Badge'},
        {wdType: 'prime', wdName: 'Prime Badge'},
        {wdType: 'amazonChoiceBadge', wdName: 'Amazon\'s choice Badge'},
        {wdType: 'price', wdName: 'Price'},
        {wdType: 'searchBan', wdName: 'Search Result Suppression'},
        {wdType: 'fbaFeeChange', wdName: 'FBA Fee Change'},
        {wdType: 'subscribeAndSave', wdName: 'Subscribe and Save'},
        {wdType: 'parentProductChange', wdName: 'Parent Product Change'},
        {wdType: 'adultClassification', wdName: 'Adult Classification'}
      ],
      amaSites: { 'DE': 'www.amazon.de', 'CN': 'www.amazon.cn', 'UK': 'www.amazon.co.uk', 'JP': 'www.amazon.co.jp', 'FR': 'www.amazon.fr', 'ES': 'www.amazon.es', 'IT': 'www.amazon.it', 'US': 'www.amazon.com', 'MX': 'www.amazon.com.mx', 'IN': 'www.amazon.in', 'CA': 'www.amazon.ca', 'BR': 'www.amazon.com.br', 'NL': 'www.amazon.nl', 'BE': 'www.amazon.com.be', 'SE': 'www.amazon.se', 'PL': 'www.amazon.pl', 'AT': 'www.amazon.at', 'ZA': 'www.amazon.co.za' },
      index: 0,
      productIDs: [],
    }
  },
  methods: {
    setGalleryParams: function (index, productIDs) {
      this.index = index
      this.productIDs = productIDs
      if (productIDs.length !== 0) window.location.hash = 'pdet-' + productIDs[index]
    },
    // #pos purple, 1-3star red, 4-5star orange
    prettyfyReviewText: (t) => t.replace(/(#\d+)/gi, '<span style=\'color:mediumpurple;\'>$1</span>').replace(/([123])-star/gi, '<span style=\'color:orangered;\'>$1&#9733;</span>').replace(/([45])-star/gi, '<span style=\'color:orange;\'>$1&#9733;</span>'),
    // rating brightyellow, review count light blue
    prettyfyRatingText: (t) => t.replace(/star rating is ([0-9.]+)[ ,]/gi, 'is <span style=\'color:lightyellow;\'>$1&#9733;</span>').replace(/(\d+) (review|rating)/gi, '<span style=\'color:lightsteelblue;\'>$1</span> $2').replace(/count is (\d+)/gi, 'count is <span style=\'color:lightsteelblue;\'>$1</span>'),
    addNewKeyword: function () {
      let keyword = $(this.$el).find('#addNewKeywordForm [name=newKeyword]').val().trim()
      if (keyword === '') return

      $(this.$el).find('#addNewKeywordForm .submit').addClass('loading')
      let tres = parseInt($(this.$el).find('#addNewKeywordForm [name=newTreshold]').val())
      this.$http.post('/api/sentinel/watchdog/keyword/create',
        {
          productId: this.productIDs[this.index],
          keyword: keyword,
          absoluteThreshold: tres > 0 ? tres : null,
        }).then((response) => {
          // Extract watchDogId from the Location header
          const locationHeader = response.headers.get('Location') || response.headers.Location
          let watchDogItemId = null
          
          if (locationHeader) {
            const match = locationHeader.match(/\/api\/sentinel\/watchdog\/(\d+)/)
            if (match) {
              watchDogItemId = parseInt(match[1])
            }
          }
          
          if (!watchDogItemId) {
            console.error('Failed to extract watchDogId from Location header:', locationHeader)
            window.alert('Error: Could not get keyword ID from server response')
            return
          }

          // Add the keyword to worldStore using the flat structure
          // The key format is "keyword_watchDogItemId"
          const newKeywordKey = `keyword_${watchDogItemId}`

          const newKeywordItem = {
            marketplace: 'US',
            status: 99,
            statusDetails: { message: 'initializing' },
            settings: { keyword: keyword, absoluteThreshold: tres > 0 ? tres : 1000 },
            muted: false,
            watchDogItemId: watchDogItemId,
            productId: this.productIDs[this.index]
          }

          // Add to flat watchDogs structure
          this.$set(this.$parent.$parent.worldStore.watchDogs, newKeywordKey, newKeywordItem)

          // reset form
          $(this.$el).find('#addNewKeywordForm [name=newKeyword]').val('')
          $(this.$el).find('#addNewKeywordForm [name=newTreshold]').val('')
          this.showAddKeywordForm = false

          // Refresh keyword data for this product to get the latest status
          if (this.$parent.productDetails) {
            this.$parent.productDetails(this.productIDs[this.index])
          }
        }, (response) => {
          console.error('Add keyword failed:', response)
          // Better error handling
          if (response.status === 409) {
            window.alert('Keyword already exists for this product')
          } else if (response.status === 400) {
            window.alert('Invalid keyword or threshold value')
          } else {
            window.alert('Error adding keyword - please try again')
          }
        }).finally(() => {
          // Always remove loading class, regardless of success or failure
          $(this.$el).find('#addNewKeywordForm .submit').removeClass('loading')
        })
    },
    removeKeyword: function (id) {
      $(this.$el).find('[data-wdid=' + id + ']').parent().parent().parent().fadeOut()
      this.$http.put('/api/sentinel/watchdog/keyword/deactivate', { watchDogId: id })
        .then((response) => {
          // Remove keyword from flat watchDogs structure
          const productId = this.productIDs[this.index]
          // Find the key with format "keyword_watchDogItemId" and delete it
          for (const [key, watchDogItem] of Object.entries(this.$parent.$parent.worldStore.watchDogs)) {
            if (key.startsWith('keyword_') && watchDogItem.watchDogItemId === id) {
              this.$delete(this.$parent.$parent.worldStore.watchDogs, key)
              break
            }
          }

          // Refresh keyword data for this product
          if (this.$parent.productDetails) {
            this.$parent.productDetails(productId)
          }
        }, (response) => {
          window.alert('error :( - please let us know this happened')
        })
    },
    galleryNext: function () {
      if (this.galleryNextButton) {
        this.index++
        // Load product details for the new product
        const newProductId = this.productIDs[this.index]
        if (this.$parent.productDetails) {
          this.$parent.productDetails(newProductId)
        }
      }
    },
    galleryPrev: function () {
      if (this.galleryPrevButton) {
        this.index--
        // Load product details for the new product
        const newProductId = this.productIDs[this.index]
        if (this.$parent.productDetails) {
          this.$parent.productDetails(newProductId)
        }
      }
    },
    hide: () => $('#productDetailModal').modal('hide'),
    salesCount: function (t, productId, salesType) {
      const getSales = id => this.$parent.$parent.worldStore.products[id].sales
      const getAllChildPIds = id => this.$parent.$parent.worldStore.products[id].productGroupProductIds
      const date = t => ((t === 'y' || t === 'ytd') ? 1 : 0)

      return getAllChildPIds(productId).reduce(
        (prevVal, id) => {
          const sales = getSales(id)
          const dateIndex = date(t)
          if (sales && sales[dateIndex] && sales[dateIndex][salesType] !== undefined) {
            return prevVal + sales[dateIndex][salesType]
          }
          return prevVal + 0
        }, 0
      )
    },
    numInGroup: function () {
      let firstIndex = this.index
      while (firstIndex >= 0 && this.$parent.$parent.worldStore.products[this.productIDs[this.index]].productGroupId === this.$parent.$parent.worldStore.products[this.productIDs[firstIndex]].productGroupId) {
        firstIndex--
      }
      return this.index - firstIndex
    },
    toMonth: (m) => ({1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'}[m]),
    hasPromoCodes: function (k) { return Object.keys(this.promoCodes[k]).length > 0 },
    getIconClasses: function (item) {
      // not using any 'else' branches to catch unhandled cases
      if (item.status === 99) return 'right grey circle icon'
      if (item.status === 0) return 'right green checkmark icon'
      if (item.status === 1 || item.status === 2) {
        if (item.issueStatus > 0 || item.muted) return 'right blue warning circle icon'
        if (item.status === 1) return 'right orange warning circle icon'
        if (item.status === 2) return 'right red warning circle icon'
      }
    },
    cycleIssueStatus: function (wdType, productId) {
      const item = this.$parent.$parent.worldStore.watchDogs[wdType].items[productId]
      if (!item) {
        this.$http.post('/api/webui/p0/rjse', {
          message: 'checkNotNullFailed, wdType:' + wdType + ', productId: ' + productId,
          url: 'cycleIssueStatus()',
          lineNumber: 0,
          columnNumber: 0,
          error: 'checkNotNullFailed',
        })
      } else if (!item.muted && item.status > 0) {
        this.$parent.$parent.setIssueStatus(item.watchDogId, (item.issueStatus === 3 ? 0 : item.issueStatus + 1))
      }
    },
    cycleKeywordIssueStatus: function (productId, index) {
      const item = this.$parent.$parent.worldStore.watchDogs['keyword'].items[productId][index]
      if (!item.muted && item.status > 0) {
        this.$parent.$parent.setIssueStatus(item.watchDogId, (item.issueStatus === 3 ? 0 : item.issueStatus + 1))
      }
    },
  },
  computed: {
    galleryPrevButton: function () { return this.productIDs.length > 1 && this.index > 0 },
    galleryNextButton: function () { return this.productIDs.length > 1 && this.index < (this.productIDs.length - 1) },

    // Direct access to current product's watchDogs data
    currentProductWatchDogs: function () {
      const productId = this.productIDs[this.index]
      if (!productId || !this.$parent.$parent.worldStore.watchDogs) {
        console.log('[ProductDetails] No productId or watchDogs:', {productId, hasWatchDogs: !!this.$parent.$parent.worldStore.watchDogs})
        return {}
      }

      const watchDogs = {}
      // The API returns a flat object with keys like "fbmInventory_1124897806397440"
      // We need to parse these and organize by watchdog type
      for (const [fullKey, watchDogItem] of Object.entries(this.$parent.$parent.worldStore.watchDogs)) {
        // Extract the watchdog type (e.g., "fbmInventory" from "fbmInventory_1124897806397440")
        const wdType = fullKey.split('_')[0]

        // Skip keyword watchdogs - they're handled separately
        if (wdType === 'keyword') continue

        // Check if this watchdog belongs to the current product
        if (watchDogItem.productId === productId) {
          watchDogs[wdType] = watchDogItem
        }
      }
      console.log('[ProductDetails] currentProductWatchDogs for', productId, ':', Object.keys(watchDogs))
      return watchDogs
    },

    // Direct access to current product's keywords
    currentProductKeywords: function () {
      const productId = this.productIDs[this.index]
      if (!productId || !this.$parent.$parent.worldStore.watchDogs) return []

      const keywords = []
      // Get all keyword watchdogs for this product
      for (const [fullKey, watchDogItem] of Object.entries(this.$parent.$parent.worldStore.watchDogs)) {
        const wdType = fullKey.split('_')[0]

        if (wdType === 'keyword' && watchDogItem.productId === productId) {
          keywords.push(watchDogItem)
        }
      }
      console.log('[ProductDetails] currentProductKeywords for', productId, ':', keywords.length, 'keywords')
      return keywords
    },
    promoCodes: function () {
      // product detail overview hasnt been used yet
      if (!(this.productIDs.length > 0)) return null
      // no sales data
      else if (this.$parent.$parent.worldStore.products[this.productIDs[this.index]].sales === null) return null
      // else: calculate everything
      const salesRanges = { today: [0], ytd: [1] } // today: [0], ytd: [1], all: [0, 1]
      const productVariations = this.$parent.$parent.worldStore.products[this.productIDs[this.index]].productGroupProductIds
      const getPCodes = (id, i) => {
        const sales = this.$parent.$parent.worldStore.products[id].sales
        if (sales && sales[i] && sales[i].promotionCodesUsedUnits) {
          return sales[i].promotionCodesUsedUnits
        }
        return {}
      }
      let rslt = { }

      // loop through each range we want to generate
      for (let r in salesRanges) {
        rslt[r] = {} // init result map
        // loop through each salesday in each range
        for (let day in salesRanges[r]) {
          // look up each child variations promo codes
          for (let item in productVariations) {
            // loop though each promo code and add to the result object
            let codes = getPCodes(productVariations[item], salesRanges[r][day])
            for (let c in codes) {
              // old:: rslt[r][c] = rslt[r].hasOwnProperty(c) ? (rslt[r][c] + codes[c]) : codes[c]
              if (rslt[r].hasOwnProperty(c)) {
                rslt[r][c].orders = rslt[r][c].orders + codes[c].orders
                rslt[r][c].units = rslt[r][c].units + codes[c].units
              } else {
                rslt[r][c] = {'orders': codes[c].orders, 'units': codes[c].units}
              }
            }
          }
        }
      }
      // console.log(rslt)
      return rslt
    },
  },
  watch: {
    productIDs: function () {
      $(this.$el).find('i[data-html]').popup('destroy') // lets not stack listeners
      setTimeout(() => { $(this.$el).find('i[data-html]').popup({ delay: { show: 0, hide: 0 }, transition: 'scale' }) }, 500)
    },
  },
  // mounted: {},
  destroyed: function () {
    $(this.$el).remove()
  },
}
</script>

<style>
.prodDetOverlayHeader {height:83px; overflow:visible;}

#muteAble .muteAble.item:hover > i.right.icon::before {display:block; text-align: center; line-height: 9px; font-family:verdana; font-size: 9px; text-decoration:underline; font-weight:bold; color:#aaa; margin: 0 0 0 -13px;}
#muteAble .inventoryItem.muteAble.item:hover > i.right.icon::before {margin: 0 0 0 1px;}
#muteAble .muteAble.item > i.right.icon:hover::before {color:#b22;}
#muteAble .muteAble.item > i.right.icon:hover{cursor: pointer;}

#muteAble .issueSt0.muteAble.item:hover > i.right.icon::before {display:block; content: "mark as Seen";}
#muteAble .issueSt1.muteAble.item:hover > i.right.icon::before {display:block; content: "mark as In Prgs";}
#muteAble .issueSt2.muteAble.item:hover > i.right.icon::before {display:block; content: "mark as Done";}
#muteAble .issueSt3.muteAble.item:hover > i.right.icon::before {display:block; content: "mark as New";}


#keywordsList .removeKeyword {display:none; float:right; text-decoration:none; color:#922 !important; font-size:10px; font-weight:normal; }
#keywordsList .removeKeyword:hover {color:#a22 !important; text-decoration:underline;}
#keywordsList .item:hover .removeKeyword{display:inline; }
</style>



// WEBPACK FOOTER //
// ProductDetails.vue?3687093b